import i18n from "./i18n";

/**
 * This is how we control which report can change their displayed locale.
 * This utility changes the current i18n language directly.
 * @param string locale 
 * @param string full absolute current path of the report
 * @returns 
 */
export default function setI18nFromTeacherReport(locale, pathname){
    if(!locale) return
    if(!pathname) return

    const supportedReports = ["/teacher/reports/type/parent"]

    /**
     * change the i18n lang back to English if not supported.
     */
    if(!supportedReports.some(reportUrl => pathname.includes(reportUrl))){
        i18n.changeLanguage('en-us')
        return
    }

    i18n.changeLanguage(locale.toLowerCase())
}